var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-presentation-image h-100",style:({ backgroundImage: 'url(\'' + _vm.imageUrl + '\')' })})}
var staticRenderFns = []

export { render, staticRenderFns }